import {JSEncrypt} from "jsencrypt";

class RSA {
    // 创建 RSA 加密对象
    encryptor = new JSEncrypt()

    // RSA 加密
    encryptPassword(password) {
        // 设置 RSA 公钥
        this.encryptor.setPublicKey(this.RSAPublicKey)

        // 使用公钥进行加密
        // 返回加密后的密码
        return this.encryptor.encrypt(password)
    }


    // 解密
    decryptPassword(password) {

        // 设置 RSA 私钥
        this.encryptor.setPrivateKey(this.RSAPrivateKey)

        // 使用私钥进行解密
        // 返回解密后的密码
        return this.encryptor.decrypt(password)
    }


    // RSA公钥
    RSAPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnA8ueqM6ygCFwNfUlAdw
OSBzNoA3mYlyXSzm4eYRS7OG3qt4kAq+8rFQ0hAnZ5rWg6Z2lAgmTbupB+p+1zCY
LcsWcxw3Lrw3rUKFcTshM/KbC40f5bjGDumZId9WSWdZ+CAsVA8Uhzx8QWw9ayhK
fDfkrnxeHnFIhcNuwEeFkK2ccu7JcRrz1FvopflHYqsCn6/5tvR4bYHOI9mA5yE7
Kd6EtmPE+QXj2WVJdv65azHbcEvJQvd5LPE3CKqqIRe1xb/fau+ZgXh/aanLJ0Ce
7Az2cQ/bmT1ICIkFzfvKpo8S0nyIslQG0PkmnG9wRuhjsStfveIa/JIcrIj7jW4R
TwIDAQAB
-----END PUBLIC KEY-----
`;
    // 私钥
    RSAPrivateKey = `
-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCcDy56ozrKAIXA
19SUB3A5IHM2gDeZiXJdLObh5hFLs4beq3iQCr7ysVDSECdnmtaDpnaUCCZNu6kH
6n7XMJgtyxZzHDcuvDetQoVxOyEz8psLjR/luMYO6Zkh31ZJZ1n4ICxUDxSHPHxB
bD1rKEp8N+SufF4ecUiFw27AR4WQrZxy7slxGvPUW+il+UdiqwKfr/m29Hhtgc4j
2YDnITsp3oS2Y8T5BePZZUl2/rlrMdtwS8lC93ks8TcIqqohF7XFv99q75mBeH9p
qcsnQJ7sDPZxD9uZPUgIiQXN+8qmjxLSfIiyVAbQ+Sacb3BG6GOxK1+94hr8khys
iPuNbhFPAgMBAAECggEAPPxl0oE1eTlpC6qMpWiev4Rh4duLXtHqwmTIuWDaQ3Yd
76iczdWVN2x5xA2SCJfm2r3TuxfQODJs5O4LsXaJEeQ6mrNdEUN2kpvbYBuWZyGY
25PD8lcZ9zvsnuMTak4cR63zBMp74DmP6VUuT1EIgrCpClMJyOXGTJfKERQiKx5B
Oz7vN1vXq9xdJ3yKUs3NCAL3hMZPS4pXjtL/agGO/fGqa6kolbPerNFuuD0wLqPb
xkShf7jjx0wmSmBLkpolp7WFLK3q+QS9eh+IDzUM3qQTX9TMlGR0XhlLm9VqoLTk
vGPaDT2jxLqotpPgqBWwMiepF3/GvUrsFJEhuEXH+QKBgQDIuWum90sdZxINPrra
/GhBLoVjLwO1B/j2IKR1YcJt+Uh7b0jOTumRL2OB+TYalsxo5l++aGTbsqYHadz7
uRXYi2IqFcx2eU5aduIH3nKOOvZ/TlA9b+q+3GLaPHrcc5a2Jr8QR7+XJpQxgNEp
PVMI+FTUwjmnmdnPrD9ajk30kwKBgQDHCPyHI7+N5qp+0Igaios/Ao3M0f2JfjUj
h0ZgC2xJJsihf8PjdEJc33FizELIoihPPh7c5mdb1YPlUSakwF9C74vjwCkMO3m3
FkFHXsjOg2XfAIV/qaB+psUQmUKSmOQi4gLL0c79rk7z1ghCdbQZLodniWNwIFeC
Np9E7A8B1QKBgQCYc7w/5DM48b/UL4DcMjk8yIim/F5kcNm2lrRSMx3pSRy0I6G4
kFb13nhFj3J4X3CBe/fcNo3kD5vqpY0h40GkZrj4HfZdRWUtcH3cXCfFvyLZLjHj
d81jiR/LgYQPS/t7/ZHAW744nySPNLeoCtu2RGap8Zq4oTG9eaXksZCj4QKBgD3o
tKvQWcfopMW3VW50A6YAxFyeQK+guySm8iPzyaXjU2qwlBzOz8mVku45PNitX75u
QylQ3Xt6KYGNwWhjkf3/BtM7tUjhwxVI7dsmR228/1XjEqNH/u0GMKveEBALUILt
LBN72leb/WDpBT6u3+spRuLUoEKDPNT66oWEq5JVAoGBAL+/Rs5pYmwH9T4HkuH9
KJGO1yn8rKozXiCAehMX7dhkI1cHQS5Yc+KJC62OwzlgRKgtLdNH/QP3SxWJ72gd
J/pZUgvpVpmEzkhxXFtAXZ+AbJ9S0hJVMu/wr/gQuzlcrCIs4Qvy4h+drTMNfWT5
c/jLUakD3eGVIV4mxnmT6vy7
-----END PRIVATE KEY-----
`;

}

export {RSA}